export default __webpack_public_path__ + "locales/it/SendInviteDialog.json?hash=21b6f90b574ce6a70a31ccb71e588d53";